import { React, Axios, Redirect, Modal, $, dt } from "../../../Headers";
import { formatDate } from "../../SortSolOrgWeb/helper";
// import Header from './Header'
import Menu from "./Menu";

const loading = (
  <div class="spinner-border text-dark" role="status">
    <span class="sr-only">Loading...</span>
  </div>
);

export default class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modelIsOpenForSubmit: false,
      modelIsOpenForResponse: false,
      modalIsOpenForHistory: false,
      response: "",
      redirect: false,
      redirecttype: "",
      server: "",
      AdminData: [],
      article_id: "",
      type: "Pending",
      HistoryData: [],
    };
  }

  ViewArticleData = (ArticleData) => {
    this.setState({ article_id: ArticleData.article_id });
    //console.log(ArticleData.article_id);
    this.setState({ redirect: true });
    this.setState({ redirecttype: "next" });
  };

  ViewHistory = (article_id) => {
    this.setState({ modalIsOpenForHistory: true });
    Axios.post(
      "//" + window.$name + "/controller/GetArticleHistoryController.php",
      {
        article: article_id,
      }
    ).then((res) => {
      //console.log(res);
      this.setState({ HistoryData: res.data });
    });
  };

  typeselect = (value) => {
    if (value === "Pending") {
      this.setState({ redirecttype: "Pending" });
      this.setState({ redirect: true });
    }
    if (value === "Approve") {
      this.setState({ redirecttype: "Approve" });
      this.setState({ redirect: true });
    }
    if (value === "Reject") {
      this.setState({ redirecttype: "Reject" });
      this.setState({ redirect: true });
    }
  };

  componentDidMount() {
    // const add = document.getElementsByClassName('current')[0];
    // console.log(add);
    // add.id = "active_page";
    // $('.current').attr('id','menu')
    // add.setAttribute('id','active_page');
    const server = window.$name;
    //console.log(server);
    this.setState({ server: server });
    //console.log(localStorage.getItem('user'));
    //console.log(localStorage.getItem('role'));

    Axios.post(
      "//" + window.$name + "/controller/GetDataForAdminTableController.php",
      {
        user_id: localStorage.getItem("user"),
        role_id: localStorage.getItem("role"),
        type: this.state.type,
      }
    )
      .then((res) => {
        //console.log(res);
        this.setState({ AdminData: res.data });
        // console.log(res.data[0].Submitted_on)
        // console.log(new Date(res.data[0].Submitted_on).toDateString())

        var dataTable = $("#table").DataTable({
          responsive: true,
          fnRowCallback: function (
            nRow,
            aData,
            iDisplayIndex,
            iDisplayIndexFull
          ) {
            //debugger;
            var index = iDisplayIndexFull + 1;
            $("td:first", nRow).html(index);
            return nRow;
          },
          columnDefs: [
            { className: "dt-center", targets: "_all" },
            { responsivePriority: 1, targets: -1 },
            { responsivePriority: 2, targets: 1 },
            { responsivePriority: 3, targets: 0 },
          ],
        });
        $("#searchbox").on("keyup search input paste cut", function () {
          dataTable.search(this.value).draw();
        });
      })
      .catch((err) => {
        //console.log(err);
      });
  }

  render() {
    if (this.state.redirect == true && this.state.redirecttype == "next") {
      return <Redirect to={"/article/" + this.state.article_id} />;
    }
    if (this.state.redirect == true && this.state.redirecttype == "Pending") {
      return <Redirect to={"/manuscript/admin/pending"} />;
    }
    if (this.state.redirect == true && this.state.redirecttype == "Approve") {
      return <Redirect to={"/manuscript/admin/approve"} />;
    }
    if (this.state.redirect == true && this.state.redirecttype == "Reject") {
      return <Redirect to={"/manuscript/admin/reject"} />;
    }
    return (
      <>
        <div id="ss-uad-article-01">
          <div className="row" id="ss-uad-article-02">
            <div
              className="col-4"
              style={{ display: "flex", alignItems: "center" }}
            >
              <p id="ss-uad-admin-02">Pending Manuscripts</p>
            </div>
            <Menu />
            <div
              class="col-4"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div class="input-group">
                <i id="ss-sad-login-011" class="fa fa-search"></i>
                <input
                  class="form-control"
                  type="text"
                  id="searchbox"
                  placeholder="Search"
                />
              </div>
            </div>
          </div>
          <div className="card-body" id="card_body">
            <div className="container-fluid">
              <center>
                {this.state.AdminData == null ? (
                  <div id="center_preloader">{loading}</div>
                ) : (
                  <table
                    id="table"
                    className="display hover dt[-head|-body]-justify"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Name Of Manuscript</th>
                        <th>Submited On</th>
                        {/* <th>Last Updated</th> */}
                        <th>Author / Institution</th>
                        <th>Action</th>
                        <th>History</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.AdminData.map((data) => (
                        <tr>
                          <td></td>
                          <td>
                            {data.title +
                              " " +
                              data.firstname +
                              "" +
                              data.lastname}
                          </td>
                          <td>{data.email}</td>
                          <td>{data.mobile}</td>
                          <td>{data.manuscript_title}</td>
                          <td>{formatDate(data.Submitted_on)}</td>
                          {/* <td>{formatDate(data.Last_Update)}</td> */}
                          {/* <td style={{ width: "20%" }}>{new Date(data.Submitted_on).getDate() + "/" + new Date(data.Submitted_on).getMonth() + "/" + new Date(data.Submitted_on).getFullYear() + " " + new Date(data.Submitted_on).toLocaleTimeString()}</td>
                                                <td style={{ width: "20%" }}>{new Date(data.Last_Update).getDate() + "/" + new Date(data.Last_Update).getMonth() + "/" + new Date(data.Last_Update).getFullYear() + " " + new Date(data.Last_Update).toLocaleTimeString()}</td> */}
                          <td>{data.organization}</td>
                          <td>
                            <div className="btn-group">
                              <button
                                type="button"
                                class="btn-lg  responsive_btn"
                                id="view"
                                title="View"
                                value="View"
                                onClick={() => this.ViewArticleData(data)}
                              >
                                <i class="fas fa-eye"></i>
                              </button>

                              {/* <button type="button" class="btn-lg  responsive_btn" id="delete" title="Delete" value="Delete" onClick={() => this.DeleteCountry(data.country_id)} ><i class="far fa-trash-alt"></i></button> */}
                            </div>
                          </td>
                          <td>
                            <div className="btn-group">
                              <button
                                type="button"
                                class="btn-lg  responsive_btn"
                                id="history"
                                title="history"
                                value="history"
                                onClick={() =>
                                  this.ViewHistory(data.article_id)
                                }
                              >
                                <i class="fas fa-history"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </center>
            </div>
          </div>
        </div>
        {/* </div> */}
        {/* </div> */}
        <Modal
          isOpen={this.state.modalIsOpenForHistory}
          className="popup-modal-content-details"
          overlayClassName="popup-modal"
          onRequestClose={() => this.setState({ modalIsOpenForHistory: false })}
        >
          {/* <span id="btn-in-popup" className="btn closed" onClick={() => this.setState({ modalIsOpenForHistory: false })}>&times;</span> */}
          <span
            class="closed"
            type="button"
            style={{
              fontSize: "32px",
              position: "absolute",
              zIndex: "1",
              right: "3%",
              height: "6.7vh",
              lineHeight: "6.7vh",
            }}
            onClick={() => this.setState({ modalIsOpenForHistory: false })}
          >
            &times;
          </span>
          <div
            className="card-header"
            id="ss-uad-article-10"
            style={{ justifyContent: "flex-start", paddingLeft: "5%" }}
          >
            {/* <i class="fas fa-comment-alt mr-2" id="ss-uad-article-11"></i> */}
            <span id="ss-uad-article-12">Manuscript History</span>
          </div>
          {/* <div class="card-body"> */}
          <center style={{ textAlign: "center" }}>
            <table
              id="table"
              className="table table-striped table-responsive table-in-popup"
              style={{ width: "100%" }}
            >
              <thead class="ss-uad-admin-03">
                <tr>
                  <th>#</th>
                  <th style={{ width: "40%" }}>Remark</th>
                  <th style={{ width: "20%" }}>Action Date</th>
                  {/* <th style={{ width: "20%" }}>Current User Name</th> */}
                  <th style={{ width: "40%" }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {this.state.HistoryData.map((data, i) => (
                  <tr>
                    <td>{i + 1}</td>
                    <td style={{ width: "40%" }}>{data.remark}</td>
                    <td style={{ width: "20%" }}>{data.action_taken}</td>
                    {/* <td>{new Date(data.action_taken).getDate() + "/" + new Date(data.action_taken).getMonth() + "/" + new Date(data.action_taken).getFullYear() + " " + new Date(data.action_taken).toLocaleTimeString()}</td> */}
                    {/* <td>{data.firstname + " "}{data.lastname}</td> */}
                    <td style={{ width: "40%" }}>{data.status_msg}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </center>
          {/* </div> */}
        </Modal>
      </>
    );
  }
}
